export default "__VITE_ASSET__BAAdreuU__"